import { APP_VERSION, COUNTRY_CODE, EnvironmentType } from "./environment.type";

export const environment: EnvironmentType = {
  placement: "prod",
  production: true,
  route_hash: false,
  timezone: "America/Bogota",
  code: COUNTRY_CODE.co,
  currency: "COP",
  grammar: "es",
  lang: "es",
  phone_length: 10,
  max_tip: 200000,
  phone_prefix: "+57",
  gateway: {
    base_url: "https://services.rappi.com",
    csv_prefix: "/api/cargo-api-gateway/csv/portal/",
    location_gateway_prefix: "/api/cargo-api-gateway/core-maps/address/",
    gateway_prefix: "/api/cargo-api-gateway/portal/",
    settlement_prefix: "/api/cargo-api-gateway/portal/settlement/",
  },
  logoUrl: "https://cargo-core-api.s3.amazonaws.com/co/cargo-logos/",
  trackingUrl: "cargo-tracking.rappi.com.co/",
  maps_api: {
    api_key: "AIzaSyBI3Dzgh8ZRnhNSEytERwTUs-SVkZ85qhE",
  },
  coordsCenter: { lat: 4.60971, lng: -74.08175 },
  currencySymbol: "$",
  decimalPattern: /^[0-9]+([.]\d{0,0})?$/,
  decimalNumber: 0,
  country: {
    defaultLocale: "es-CO",
  },
  localeUrl: "https://cargo-core-api.s3.amazonaws.com/co/cargo-logos/",
  auth0: {
    client_id: "T22HL1Vp2Oc6kKhxEo55ndT816Ru37L9",
    client_secret: "BxWgxvG5ysBdlwMmG9tqFOG8OU8qCrBFIynQ1Jrq_nxr7WTZbih8T-iaeHKhBOsc",
    domain: "https://login.partners.rappi.com",
  },
  amplitude: {
    key: "032f00f0dfdad881e7391f28f35156f6",
  },
  OAuthGateway: "https://www.rappi.com.co/login-legacy/signup",
  i18n_version: APP_VERSION,
  kustomer_assistant_id: "664bbe3419e7a2316b52dc7a",
};
